import Instance from "../../../../Axios";

// New Actions for the app

const GetWorkPermitRespEntities = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/respEntities`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_WORK_PERMIT_RESP_ENTITIES", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetWorkPermitRespEntities;